import * as Sentry from '@sentry/react';

import { getConfig } from 'pkg/config/app';

let sentryEnabled = false;

type LogLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

interface LogData {
	[key: string]: unknown;
}

export function init(): void {
	const { sentryDsn, version } = getConfig();

	if (!sentryDsn) {
		return;
	}

	Sentry.init({ dsn: sentryDsn, release: version });

	sentryEnabled = true;
}

function capture(msg: string | Error, level: LogLevel, data?: LogData): void {
	Sentry.addBreadcrumb({
		category: 'log',
		message: typeof msg === 'string' ? msg : msg.message,
		level,
		data,
	});

	if (!sentryEnabled || !['fatal', 'error', 'warning'].includes(level)) {
		return;
	}

	Sentry.withScope((scope) => {
		if (data) {
			scope.setContext('Log Info', data);
		}

		if (msg instanceof Error) {
			Sentry.captureException(msg);
		} else {
			Sentry.captureMessage(msg, level);
		}
	});
}

export function debug(msg: string, data?: LogData): void {
	capture(msg, 'debug', data);
}

export function warning(msg: string, data?: LogData): void {
	capture(msg, 'warning', data);
}

export function error(err: Error, data?: LogData): void {
	capture(err, 'error', data);
}
